import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import configureStore from './store';
// import registerServiceWorker from './registerServiceWorker';

import './styles/index.scss';

const baseUrl = '/proposal-builder/';
// || document.getElementsByTagName('base')[0].getAttribute('href');

const initApp = async () => {
    const rootElement = document.getElementById('root') as HTMLElement;

    const store = await configureStore(undefined);

    const root = createRoot(rootElement);
    root.render(
        <Provider store={store}>
            <BrowserRouter basename={baseUrl}>
                <App />
            </BrowserRouter>
        </Provider>
    );
};

initApp();

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
// registerServiceWorker();
